<!--
 * @Author: your name
 * @Date: 2020-12-12 18:32:09
 * @LastEditTime: 2020-12-14 14:54:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/tab-admin/components/time-field.vue
-->
<template lang="pug">
.__input_field
  label.label {{ $attrs.name }}
  van-field(
    v-bind="$attrs"
    v-on="$listeners"
    readonly
    clickable
    :value="value"
    :disabled="disabled"
    @click="showPicker = true"
  )

  van-popup(v-if="!disabled" v-model="showPicker" position="bottom")
    van-datetime-picker(
      type="time"
      :filter="filter"
      :min-hour="minHour"
      :min-minute="minMinute"
      @confirm="onTimeConfirm"
      @cancel="showPicker = false"
    )</template>

<script>
import dayjs from 'dayjs'

export default {
  props: {
    value: [Number, String],
    date: String,
    disabled: Boolean
  },

  watch: {
    date: {
      handler(val) {
        this.minHour = 0
        this.minMinute = 0
        if (val === dayjs.tz().format('DD/MM/YYYY')) {
          this.minHour = dayjs.tz().format('HH')
          this.minMinute = dayjs.tz().format('mm')
        }
      },
      immediate: true
    }
  },

  data() {
    return {
      showPicker: false,
      minHour: 0,
      minMinute: 0
    }
  },

  methods: {
    onTimeConfirm(time) {
      // @todo format time to am pm
      this.$emit('input', time)
      this.showPicker = false
    },

    filter(type, options) {
      // 对选项数组进行过滤，实现自定义时间间隔
      if (type === 'minute') {
        return options.filter((option) => option % 15 === 0)
      }
      return options
    },
  },
}
</script>

<style lang="sass" scoped>
@use "./vant-field" as *
</style>